// @core/api/endpoints/subscription/list_discounts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDiscountsResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List discounts
 * Returns all discount codes with optional filtering by active status and expiration. Includes usage statistics for each code.
 */
export async function ListDiscounts(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDiscountsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/discounts`;
  const requestOptions = options;
  return client.get<ListDiscountsResponse>(requestPath, { ...requestOptions, params });
}
